<div class="envio-confirmacion-grid__scroll">
  <table class="envio-confirmacion-grid" *ngIf="firmantes.length; else sinFirmantes">
    <thead>
      <tr>
        <th scope="col">Orden</th>
        <th scope="col">Tipo firmante</th>
        <th scope="col">Nombre</th>
        <th scope="col">Apellido 1</th>
        <th scope="col">Apellido 2</th>
        <th scope="col" *ngIf="mostrarEmail">E-mail personal</th>
        <th scope="col" *ngIf="mostrarTelefono">Telefono</th>
        <th scope="col" class="envio-confirmacion-grid__col-estado">Estado envío</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let firmante of firmantes; trackBy: trackByCodigo">
        <td>{{ firmante.orden }}</td>
        <td>{{ firmante.tipoFirmante }}</td>
        <td>{{ firmante.nombre }}</td>
        <td>{{ firmante.apellido1 }}</td>
        <td>{{ firmante.apellido2 }}</td>
        <td *ngIf="mostrarEmail">{{ firmante.email }}</td>
        <td *ngIf="mostrarTelefono">{{ firmante.telefono }}</td>
        <td class="envio-confirmacion-grid__col-estado">
          <span
            class="envio-confirmacion-grid__estado"
            [ngClass]="claseEstado(firmante.estadoEnvio)"
            [matTooltip]="firmante.mensajeEstado || ''"
            [matTooltipDisabled]="!firmante.mensajeEstado"
            matTooltipClass="envio-confirmacion-grid__tooltip">
            {{ firmante.estadoEnvio }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #sinFirmantes>
  <p class="envio-confirmacion-grid__vacio">No hay firmantes en el resumen del envío.</p>
</ng-template>
